// extracted by mini-css-extract-plugin
module.exports = {"root":"SmallRemainsIndicator_root__26Fif","indicator":"SmallRemainsIndicator_indicator__3RBDW"};